import { render, staticRenderFns, recyclableRender, components } from "./u-subsection.vue?vue&type=template&id=78c1286e&scoped=true&"
var renderjs
import script from "./u-subsection.vue?vue&type=script&lang=js&"
export * from "./u-subsection.vue?vue&type=script&lang=js&"
import style0 from "./u-subsection.vue?vue&type=style&index=0&id=78c1286e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Program Files/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c1286e",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-subsection/u-subsection.vue"
export default component.exports